const Navlinks = {
  home: "/",
  queHacemos: "/que-hacemos",
  presentacion: "/presentacion",
  definiciones: "/definiciones",
  patronDeCasos: "/patron-de-casos",
  metodologia: "/metodologia",
  investigaciones: "/investigaciones",
  novedades: "/novedades",
  redRadar: "/red",
} as const;

export default Navlinks;
